import { Avatar, AvatarFallback, AvatarImage } from '@e2n/ui';
import { Arbeitszeit } from '@/domain/termine/shared/types/Arbeitszeit';
import { markierungMapper } from '@/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Markierung } from '@/domain/termine/components/Markierung/Markierung';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { formatDateTimeRange } from '@/domain/termine/shared/utils/formatDateTime';
import { useTranslation } from 'react-i18next';

function ArbeitszeitRow({ arbeitszeit }: { arbeitszeit: Arbeitszeit }) {
  return (
    <div className="flex gap-2 items-center justify-between w-full transition-all first:pt-2">
      <div className="flex items-center gap-2">
        <Avatar className="w-8 h-8">
          <AvatarImage
            src={arbeitszeit.mitarbeiter.bildUrl ?? undefined}
            alt={`${arbeitszeit.mitarbeiter.vorname} ${arbeitszeit.mitarbeiter.nachname}`}
          />
          <AvatarFallback>
            <FontAwesomeIcon icon={faUser} size="lg" />
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          <span className="text-neutrals-900 text-sm">
            {arbeitszeit.mitarbeiter.vorname} {arbeitszeit.mitarbeiter.nachname}
          </span>
          <div className="flex items-center gap-1 text-xs font-normal text-neutrals-700">
            {arbeitszeit.arbeitsbereich.markierung && (
              <Markierung
                color={
                  markierungMapper[arbeitszeit.arbeitsbereich.markierung].base
                }
              />
            )}
            {formatDateTimeRange(
              arbeitszeit.datum,
              arbeitszeit.beginn,
              arbeitszeit.ende,
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function TerminVerknuepfungArbeitszeit({
  arbeitszeiten,
  hiddenArbeitsbereich,
}: {
  arbeitszeiten: Arbeitszeit[];
  hiddenArbeitsbereich: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 max-h-60 overflow-y-auto">
      {arbeitszeiten.map((arbeitszeit) => (
        <ArbeitszeitRow key={arbeitszeit.id} arbeitszeit={arbeitszeit} />
      ))}
      {hiddenArbeitsbereich && (
        <span className="text-xs pt-3">
          {t('domain.termine.hiddenArbeitsbereich')}
        </span>
      )}
    </div>
  );
}
